import GroupedInput from '@/components/forms/GroupedInput';
import { Container } from '@/components/layout/Container';
import { COLORS } from '@/styles/color';
import { BREAKPOINT_PADDING_VAR, mediaBreakpointOnly, mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

export const Wrapper = styled(Container)`
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  row-gap: 40px;

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    column-gap: 20px;
    padding-top: 40px;
  }

  ${mediaBreakpointUp('desktop')} {
    padding-top: 60px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-template-columns: repeat(18, 1fr);
    padding-top: 80px;
  }
`;

export const Heading = styled.h1`
  ${customTextSize(32, 38)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  text-align: center;
  letter-spacing: -0.01em;
  margin-bottom: 30px;

  ${mediaBreakpointUp('desktop')} {
    text-align: left;
    ${customTextSize(49, 58)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    margin-top: 13px;
  }
`;

export const TextContainer = styled.div`
  ${customTextSize(18, 26)}
  text-align: center;
  margin-bottom: 40px;

  > * + * {
    margin-top: 15px;
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(16, 24)}
    margin-bottom: 30px;
  }

  ${mediaBreakpointUp('desktop')} {
    text-align: left;
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(24, 34)}
  }
`;

export const StyledGroupedInput = styled(GroupedInput)`
  --grouped-input-border-color: ${COLORS.BLUE.LOWLIGHT};
  --button-color: var(--grouped-input-border-color);
  --button-color-hover: ${COLORS.BLUE.BASE};

  width: 100%;
  margin: 0 auto;

  ${mediaBreakpointUp('desktop')} {
    margin: 0;
    max-width: 410px;
  }
`;

export const LeftColumn = styled.div`
  text-align: center;

  ${mediaBreakpointUp('tablet')} {
    grid-column: 2 / -2;
  }

  ${mediaBreakpointUp('desktop')} {
    text-align: left;
    grid-column: 1 / span 6;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 1 / span 9;
  }
`;

export const RightColumn = styled.div`
  position: relative;

  ${mediaBreakpointUp('tablet')} {
    grid-column: 2 / -2;
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column: 7 / span 6;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 10 / span 9;
  }
`;

export const IllustrationWrapper = styled.div`
  position: relative;

  img {
    width: 100%;
  }

  ${mediaBreakpointOnly('mobile')} {
    width: calc(100% + ${BREAKPOINT_PADDING_VAR});
    left: calc(${BREAKPOINT_PADDING_VAR} / -2);
  }
`;

export const EyebrowText = styled.div`
  font-weight: ${FONT_WEIGHTS.BOLD};
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  text-align: inherit;
`;
